import request from '@/utils/request'

// 区域数据 同步
export function commonRegion(params) {
  return request({
    url: '/super/index/region',
    method: 'get',
    params,
  })
}

export function applyAutio(id, data) {
  return request({
    url: `/super/Enterprise/audit/id/${id}`,
    method: 'post',
    data,
  })
}

export function getList(params) {
  return request({
    // url: '/api/apply',
    url: '/super/Enterprise/index',
    method: 'get',
    params,
  })
}
export function getRecycle(params) {
  return request({
    url: '/api/apply/recycle',
    method: 'get',
    params,
  })
}

export function doAdd(data) {
  return request({
    url: '/super/Enterprise/create',
    method: 'post',
    data,
  })
}

export function checkSeatCount() {
  return request({
    url: '/super/Enterprise/checkSeatCount',
    method: 'get',
  })
}

export function operationId(data, method, id = '') {
  return request({
    url: `/super/Enterprise/show/id/${id}`,
    method,
    data,
  })
}

export function deleteEnterprise(id) {
  return request({
    url: `/super/Enterprise/delete/id/${id}`,
    method: 'post',
  })
}


export function deleteBatchEnterprise(ids) {
  return request({
    url: `/super/Enterprise/batchDelete/ids/${ids}`,
    method: 'post',
  })
}

export function updateEnterprise(data) {
  return request({
    url: `/super/Enterprise/update`,
    method: 'post',
    data,
  })
}

export function operationIdDel(data, method, id = '') {
  return request({
    url: `/api/apply/del/${id}`,
    method,
    data,
  })
}

export function doRecovery(data) {
  return request({
    url: '/api/apply/recovery',
    method: 'post',
    data,
  })
}
export function doRecoveryId(data, method, id = '') {
  return request({
    url: `/api/apply/recovery${id}`,
    method,
    data,
  })
}
export function doRestoreId(id) {
  return request({
    url: `/super/Enterprise/batchRestore/ids/${id}`,
    method: 'post',
  })
}

export function adminGroup(params) {
  return request({
    url: '/api/admin_group',
    method: 'get',
    params,
  })
}

export function plugins(params) {
  return request({
    url: '/api/plugins',
    method: 'get',
    params,
  })
}
export function opPlugins() {
  return request({
    url: `/super/Index/getPlugs`,
    method: 'get'
  })
}

export function operationGroup(data = {}, method, id = '') {
  return request({
    url: `/api/admin_group/${id}`,
    method,
    data,
  })
}

export function addGroup(data) {
  return request({
    url: '/api/admin_group',
    method: 'post',
    data,
  })
}

export function addAdmins(data) {
  return request({
    // url: '/api/admins',
    url: `/super/UserCenter/create`,
    method: 'post',
    data,
  })
}

export function adminsState(data = {}, method, id = '') {
  return request({
    url: `/api/admins/state/${id}`,
    method,
    data,
  })
}
export function applyState(data = {}, method, id = '') {
  return request({
    url: `/api/apply/state/${id}`,
    method,
    data,
  })
}

export function adminsAudit(data = {}) {
  return request({
    // url: `/api/admins/audit/${id}`,
    url: `/super/UserCenter/audit`,
    method: 'post',
    data,
  })
}

export function adminList(params) {
  return request({
    url: '/super/UserCenter/list',
    method: 'get',
    params,
  })
}

export function recoveryList(params) {
  return request({
    // url: '/api/admins/recovery',
    url: `/super/UserCenter/recovery`,
    method: 'get',
    params,
  })
}
export function adminsDel(data) {
  return request({
    url: `/super/UserCenter/realDelete`,
    method: 'post',
    data,
  })
}
export function adminsRestore(data) {
  return request({
    url: `/super/UserCenter/restore`,
    method: 'post',
    data,
  })
}
//获取店铺套餐列表
export function getMusterList(params) {
  return request({
    url: '/super/Setmeal/index',
    method: 'get',
    params,
  })
}

// 删除店铺套餐
export function deleteMuster(id) {
  return request({
    url: `/super/Setmeal/delete/id/${id}`,
    method: 'delete',
  })
}

//添加店铺套餐
export function musterStore(data) {
  return request({
    url: '/super/Setmeal/create',
    method: 'post',
    data,
  })
}

//修改店铺套餐信息
export function operationMuster(data = {}, id = '') {
  return request({
    url: `/super/Setmeal/show/id/${id}`,
    method: 'get',
    data,
  })
}

export function operationMusterUpdate(data = {}) {
  return request({
    url: `/super/Setmeal/update`,
    method: 'post',
    data,
  })
}

//代理商列表
export function getAgentList(params) {
  return request({
    url: '/api/agent',
    method: 'get',
    params,
  })
}

//新增代理商
export function addAgent(data) {
  return request({
    url: '/api/agent',
    method: 'post',
    data,
  })
}

//修改代理商
export function agentId(params, method, id = '') {
  return request({
    url: `/api/agent/${id}`,
    method,
    params,
  })
}

//更改代理商
export function agentRecovery(data) {
  return request({
    url: '/api/agent/recovery',
    method: 'post',
    data,
  })
}

//普通用户列表
export function admins(params) {
  return request({
    // url: '/api/admins',
    url: '/super/UserCenter/index',
    method: 'get',
    params,
  })
}
export function adminsId(data, method, id = '') {
  return request({
    // url: `/api/admins/${id}`,
    url: `/super/UserCenter/show/id/${id}`,
    method,
    data,
  })
}

export function adminsUpdate(data, method, id = '') {
  return request({
    // url: `/api/admins/${id}`,
    url: `/super/UserCenter/update/id/${id}`,
    method,
    data,
  })
}
export function adminsDelete(data) {
  return request({
    url: `/super/UserCenter/delete`,
    method: 'post',
    data,
  })
}

//进入店铺
export function enterPosition(data) {
  return request({
    url: '/api/login/enterPosition',
    method: 'post',
    data,
  })
}

export function systemIndex(params) {
  return request({
    // url: '/api/apply/survey',
    url: '/super/apply/survey',
    method: 'get',
    params,
  })
}

export function domainInfo() {
  return request({
    url: '/super/index/domainInfo',
    method: 'get'
  })
}

// get获取客服列表 post 根据客服id查找相对应的记录
// export function getCustomerList(params, method) {
//   return request({
//     url: '/api/customer/get-customer-list',
//     method,
//     params,
//   })
// }
export function getCustomerList(params) {
  return request({
    url: '/api/customer/get-customer-list',
    method: 'get',
    params,
  })
}

// 添加客服列表或编辑客服信息
export function saveCustomer(params) {
  return request({
    url: '/api/customer/save-customer',
    method: 'post',
    params,
  })
}

/*
修改客服状态
request parameter
id 客服id
type 1启用禁用 2 删除
*/
export function changeCustomer(params) {
  return request({
    url: '/api/customer/change-customer',
    method: 'post',
    params,
  })
}

export function getPlug(params) {
  return request({
    url: '/super/Plug/index',
    method: 'get',
    params,
  })
}

export function getSmsCombo(params) {
  return request({
    url: '/api/smsCombo',
    method: 'get',
    params,
  })
}
export function operationPlug(data = {}, method, id = '') {
  return request({
    url: `/api/plug/${id}`,
    method,
    data,
  })
}
export function plugState(data) {
  return request({
    url: '/api/plug/state',
    method: 'post',
    data,
  })
}

export function saveSmsCombo(data) {
  return request({
    url: '/api/smsCombo',
    method: 'post',
    data,
  })
}
export function changeState(id) {
  return request({
    url: `/api/smsCombo/state/${id}`,
    method: 'post',
  })
}
export function adminsSmsCombo(data = {}, method, id = '') {
  return request({
    url: `/api/smsCombo/${id}`,
    method,
    data,
  })
}
export function operationAuthPlug(data, method, id = '') {
  return request({
    url: `/api/apply/authPlug/${id}`,
    method,
    data,
  })
}
export function operationDisplay(data, method, id = '') {
  return request({
    url: `/api/apply/display/${id}`,
    method,
    data,
  })
}
/*
短信
 */
// 调整店铺短信条数
export function smsAccount(id = '', method, data) {
  return request({
    url: `/api/smsAccount/${id}`,
    method,
    data,
  })
}

//获取快速注册小程序列表
export function getMiniReg(params) {
  return request({
    url: '/api/mini/register',
    method: 'get',
    params,
  })
}
//注册小程序
export function postMiniReg(data) {
  return request({
    url: '/api/mini/register',
    method: 'post',
    data,
  })
}
//编辑小程序&&删除小程序
export function pMiniReg(id = '', method, data, headers) {
  return request({
    url: `/api/mini/register/${id}`,
    method,
    data,
    headers,
  })
}
